<script setup  lang="ts">
/**
 * The Dev Helper
 * --------------------------------
 * Dev only helper with useful quick actions
 * When active, it shows when hovering bottom left area of screen with mouse.
 */

import { onClickOutside } from '@vueuse/core';

const { locale, setLocale } = useI18n();
const { addToast, reset: resetToasts } = useToasts();
const { resetAllStores, resetOfferFlow } = useResetStores();
const { reloadOffers, isLoading: isReloadingOffers } = useReloadOffers();

const visible = ref(false);
const container = useTemplateRef<HTMLElement>('container');

onClickOutside(container, () => visible.value = false);

async function resetAll() {
    await navigateTo('/');
    resetAllStores();
    resetToasts();
}

function resetOrigin() {
    const { product } = useProduct<ProductP2P>();
    product.value.origin = undefined;
}

function resetUpsellOffers() {
    const cartStore = useCartStore();
    cartStore.products.filter(p => p.isUpsell).forEach(p => p.offer = undefined);
}

function reloadCartOffers() {
    const cartStore = useCartStore();
    useLoading([isReloadingOffers]);
    reloadOffers(cartStore.products);
}

function addTestToast() {
    addToast(`key-${Math.random()}`, Math.random() > 0.5 ? 'info' : 'error', 'Aut doloremque perspiciatis repellat dolorem et sit molestiae. Cum labore cupiditate. Ab quisquam incidunt suscipit deserunt molestiae officiis.', 0, true);
}

function toggleI18n() {
    // @ts-expect-error haltdschnorre
    setLocale(locale.value === 'debug' ? 'de' : 'debug');
}

function add5Pax() {
    for (let i = 0; i < 5; i++) {
        addPax();
    }
}

function add10Pax() {
    for (let i = 0; i < 10; i++) {
        addPax();
    }
}

function addPax() {
    const passengerStore = usePassengerStore();
    const passenger = getEmptyPassenger();
    passenger.firstName = 'Test';
    passenger.dateOfBirth = new Date(1970 + Math.floor(Math.random() * 25), Math.floor(Math.random() * 12), 1 + Math.floor(Math.random() * 28));
    passenger.firstName = `Test${passengerStore.passengers.length + 1}`;
    passengerStore.addPassenger(passenger);
}
</script>

<template>
    <div>
        <div
            ref="container"
            class="
                fixed
                bottom-[68px]
                left-0
                z-50
                grid
                -translate-x-full
                grid-cols-2
                gap-x-2
                gap-y-4
                rounded-sm
                bg-shade-6
                p-3
                typo-meta-xs
                text-white
                transition-transform
                print:hidden
            "
            :class="{ 'translate-x-3': visible }"
            @click="visible = false"
        >
            <div>
                <h4 class="mb-2 typo-meta-s-bold">
                    Reset
                </h4>
                <ul class="space-y-0.5">
                    <li>
                        <button class="hover:underline" @click="resetAll">
                            Reset All
                        </button>
                    </li>
                    <li>
                        <button class="hover:underline" @click="resetOfferFlow">
                            Reset Offer Flow
                        </button>
                    </li>
                    <li>
                        <button class="hover:underline" @click="resetOrigin">
                            Reset Trip Origin
                        </button>
                    </li>
                    <li>
                        <button class="hover:underline" @click="resetUpsellOffers">
                            Clear Upsell offers
                        </button>
                    </li>
                </ul>
            </div>

            <div>
                <h4 class="mb-2 typo-meta-s-bold">
                    Test Data
                </h4>
                <ul class="space-y-0.5">
                    <li>
                        <button class="hover:underline" @click="addTestToast">
                            Set Test Toast
                        </button>
                    </li>
                    <li>
                        <button class="hover:underline" @click="toggleI18n">
                            Remove i18n values
                        </button>
                    </li>
                    <li>
                        <button class="hover:underline" @click="add5Pax">
                            Add 5 passengers
                        </button>
                    </li>
                    <li>
                        <button class="hover:underline" @click="add10Pax">
                            Add 10 passengers
                        </button>
                    </li>
                </ul>
            </div>

            <div>
                <h4 class="mb-2 typo-meta-s-bold">
                    Switch Locale
                </h4>
                <LanguageSwitcher />
            </div>

            <div>
                <h4 class="mb-2 typo-meta-s-bold">
                    Reload
                </h4>
                <ul class="space-y-0.5">
                    <li>
                        <button class="hover:underline" @click="reloadCartOffers">
                            Reload all cart offers
                        </button>
                    </li>
                </ul>
            </div>
        </div>

        <div
            class="
                fixed
                bottom-[68px]
                left-3
                flex
                size-12
                origin-left
                cursor-pointer
                items-center
                justify-center
                rounded-full
                border-4
                border-shade-2
                bg-shade-1
                typo-meta-xs
                opacity-0
                transition-opacity
                hover:opacity-100
                max-md:bottom-[90px]
                max-md:scale-50
                pointer-coarse:opacity-100
            "
            @click="visible = !visible"
        >
            <Icon name="tot:settings" class="size-4 text-shade-4" />
        </div>
    </div>
</template>
